export default __webpack_public_path__ + "5b5e4a159a16fafc94fab4436936d707.png";